import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

import {
  HOME_URL,
  JOBS_URL,
  CRITERIA_URL,
  CONTACT_URL,
  FAQ_APP_URL,
  FAQ_EMP_URL,
} from '../../../constants/navRoutes';

import {
  JOBSBOARD_TITLE,
  JOBS_TITLE,
  CRITERIA_TITLE,
  CONTACT_TITLE,
  APPLICANTS_TITLE,
  EMPLOYERS_TITLE,
} from '../../../constants/titles';

import {
  colours,
  fontSize,
  spacing,
  breakpoints,
} from '../../../theme';

import { ReactComponent as Exit } from '../../../assets/exit-black.svg';

const Container = styled.section`
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: ${props => props.burgerActive};
  top:0;
  background: ${colours.yellow};
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-around;
  transition: all 0.5s ease;

  @media (min-width: ${breakpoints.mobile}) {
    display: none;
    visibility: hidden;
  }

`;

const Link = styled(NavLink)`
    color: ${colours.black};
    font-size: ${fontSize.drawer};
    text-decoration: none;
    width: max-content;
    margin: ${spacing.tiny} 0;
    margin-right: ${spacing.tiny}
`;

const Cross = styled(Exit)`
    margin-top: ${spacing.small};
    margin-right: ${spacing.medium}
`;

const Drawer = ({ updateTitle, burgerActive, setBurgerActive }) => {

  const updateBurgerState = () => {
    setBurgerActive('100vw');
  };

  return (
    <Container burgerActive={burgerActive}>
      <Cross onClick={() => updateBurgerState()} />
      <Link exact to={HOME_URL} onClick={() => updateTitle(JOBSBOARD_TITLE)}>Home</Link>
      <Link to={JOBS_URL} onClick={() => updateTitle(JOBS_TITLE)}>Jobs</Link>
      <Link to={CRITERIA_URL} onClick={() => updateTitle(CRITERIA_TITLE)}>Criteria</Link>
      <Link to={CONTACT_URL} onClick={() => updateTitle(CONTACT_TITLE)}>Get In Touch</Link>
      <Link to={FAQ_APP_URL} onClick={() => updateTitle(APPLICANTS_TITLE)}>Applicants</Link>
      <Link to={FAQ_EMP_URL} onClick={() => updateTitle(EMPLOYERS_TITLE)}>Employers</Link>
    </Container>
  );
};

export default Drawer;
